import FF from "@/components/forms/FormField.module.css";

import type { FormSubmitButtonProps } from "@/components/forms/FormSubmitButton.tsx";
import { FormActions, FormSubmitButton } from "@/components/forms/FormSubmitButton.tsx";
import type { ResourceType } from "@/modules/api/resourceTypes.tsx";
import { billingStateAtom } from "@/modules/billing/billingLogic.tsx";
import { NoValidBillingAccountNotice } from "@/modules/billing/NoValidBillingAccountNotice.tsx";
import { useSuspenseQueryAtom } from "@/utils/query/useSuspenseQueryAtom.ts";
import { Trans } from "@lingui/react/macro";

interface CreateFormActionProps extends FormSubmitButtonProps {
    resourceType: ResourceType;
}

export const t_Create_Button = <Trans comment="Button: Create a new resource">Create</Trans>;

/** A "Create" button that automatically sets the loading state from the form */
export function CreateFormAction({ resourceType, ...props }: CreateFormActionProps) {
    const state = useSuspenseQueryAtom(billingStateAtom);

    return (
        <FormActions>
            {state.canCreateResource(resourceType) ? (
                <FormSubmitButton {...props}>{t_Create_Button}</FormSubmitButton>
            ) : (
                <div className={FF.Notice}>
                    <NoValidBillingAccountNotice state={state} />
                </div>
            )}
        </FormActions>
    );
}
